import type { FunctionComponent } from 'react';

import { Tabs, type TabsListProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { breakpoints } from 'styles/theme.variables';

/**
 * Responsive wrapper around Mantine's `Tabs.List` that automatically
 * switches between SM (16px) and LG (20px) tab sizing at the mobile
 * breakpoint. Use this instead of `Tabs.List` directly.
 */
export const TabList: FunctionComponent<TabsListProps> = props => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  return <Tabs.List mb="xl" {...props} data-size={isMobile ? 'sm' : 'lg'} />;
};
